import { $, w } from './constants';

$(function () {
    const $banner_mobile  = $('#spotify_banner_mobile');
    const $banner_desktop = $('#spotify_banner_desktop');
    if (!$banner_desktop.length && !$banner_mobile.length) return;

    const mqMobile = window.matchMedia('(max-width: 950px)');
    const $close_mobile  = $('#spotify_banner_close_mobile');
    const $close_desktop = $('#spotify_banner_close_desktop');

    let lastScrollTop = $(window).scrollTop() || 0;
    let mobileScrollBound = false;
    let isAnimating = false;

    function bindScrollOnce() {
        if (mobileScrollBound) return;
        mobileScrollBound = true;

        $(window).on('scroll.spotifyBanner', function () {
        if (isClosed()) {
            $(window).off('scroll.spotifyBanner');
            mobileScrollBound = false;
            $banner_mobile.hide();
            changeHeight();
            return;
        }

        if (isAnimating) return;

        const nowScrollTop = $(this).scrollTop();

        if (nowScrollTop > lastScrollTop) {
            isAnimating = true;
            $banner_mobile.slideUp(150, function () {
            isAnimating = false;
            changeHeight();
            });
        } else if (nowScrollTop < lastScrollTop) {
            isAnimating = true;
            $banner_mobile.slideDown(150, function () {
            isAnimating = false;
            changeHeight();
            });
        }

        lastScrollTop = nowScrollTop;
        });
    }

    function enableMobile() {
        if (isClosed()) {
        $banner_mobile.hide();
        $banner_desktop.hide();
        $(window).off('scroll.spotifyBanner');
        mobileScrollBound = false;
        changeHeight();
        return;
        }

        $banner_desktop.hide();
        $banner_mobile.show();
        changeHeight();

        lastScrollTop = $(window).scrollTop() || 0;
        bindScrollOnce();
    }

    function disableMobile() {
        $(window).off('scroll.spotifyBanner');
        mobileScrollBound = false;

        if (isClosed()) {
        $banner_mobile.hide();
        $banner_desktop.hide();
        changeHeight();
        return;
        }

        $banner_mobile.hide();
        $banner_desktop.show();
        changeHeight();
    }

    if (isClosed()) {
        $banner_mobile.hide();
        $banner_desktop.hide();
        changeHeight();
        return;
    } else {
        $banner_mobile.show();
        $banner_desktop.show();
    }

    $close_desktop.on('click', function () {
        sessionStorage.setItem('bannerSpotify', 'true');
        $(window).off('scroll.spotifyBanner');
        mobileScrollBound = false;

        $banner_desktop.fadeOut(150, function () {
        changeHeight();
        });
    });

    $close_mobile.on('click', function () {
        sessionStorage.setItem('bannerSpotify', 'true');
        $(window).off('scroll.spotifyBanner');
        mobileScrollBound = false;

        if (isAnimating) return;
        isAnimating = true;

        $banner_mobile.slideUp(150, function () {
        isAnimating = false;
        $banner_mobile.hide();
        changeHeight();
        });
    });

    if (mqMobile.matches) enableMobile();
    else disableMobile();

    const onChange = (e) => {
        if (e.matches) enableMobile();
        else disableMobile();
    };

    if (mqMobile.addEventListener) mqMobile.addEventListener('change', onChange);
    else mqMobile.addListener(onChange);

    $(w).on('resize.spotifyBanner', function () {
        changeHeight();
    });
});

function changeHeight() {
    const $wrapper = $('.podcast_banner');
    const $header = $('#header_general');
    const height = $header.outerHeight() || 0;
    $wrapper.css('--padding-top', height + 'px');
}

const isClosed = () => sessionStorage.getItem('bannerSpotify') === 'true';